var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-price" }, [
    _c("span", { staticClass: "product-price__price" }, [
      _vm._v(_vm._s(_vm._f("moneyWithoutDecimals")(_vm.product.price)))
    ]),
    _vm.isOnSale
      ? _c(
          "s",
          {
            staticClass: "product-price__price product-price__price--compare-at"
          },
          [_vm._v(_vm._s(_vm._f("moneyWithoutDecimals")(_vm.comparePrice)))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }